import { connector } from "utils/common/connector";
import { encryptText } from "../../utils/encryptText/encryptText";

const controller = "user";

// ---------------------------------------------
// GET USER BY ID
// ---------------------------------------------
export const getUserByIdService = async (params) => {
  let reply;

  try {
    const response = await connector.get(controller, "getUsersById", params);

    reply = {
      user: response ?? {},
    };
  } catch (error) {
    console.log(error);
    reply = {
      user: {},
    };
  }

  return reply;
};

// ---------------------------------------------
// GET USERS BY COMPANY
// ---------------------------------------------
export const getUsersByCompanyService = async (params) => {
  let reply;

  try {
    const response = await connector.get(
      controller,
      "getUsersByCompany",
      params,
    );

    reply = {
      users: response ?? [],
    };
  } catch (error) {
    console.log(error);
    reply = {
      users: [],
    };
  }

  return reply;
};

// ---------------------------------------------
// GET USERS WITHOUT TEAM (PAGINATED)
// ---------------------------------------------
export const getUsersNoTeamService = async (params) => {
  let reply;

  try {
    const response = await connector.get(controller, "getUserNoteam", params);

    reply = {
      users: response?.users ?? [],
      totalRecords: response?.totalRecords ?? 0,
    };
  } catch (error) {
    console.log(error);
    reply = {
      users: [],
      totalRecords: 0,
    };
  }

  return reply;
};

// ---------------------------------------------
// UPDATE USER
// ---------------------------------------------
export const updateUserService = async (params) => {
  let reply;

  try {
    const response = await connector.post(controller, "updateUser", {
      userId: params?.userId,
      updateFields: params?.updateFields,
    });

    reply = {
      user: response ?? {},
    };
  } catch (error) {
    console.log(error);
    reply = {
      user: {},
    };
  }

  return reply;
};

// ---------------------------------------------
// ADD USER TO TEAM
// ---------------------------------------------
export const addTeamUserService = async (params) => {
  let reply;

  try {
    const response = await connector.post(controller, "addTeamUser", {
      userId: params?.userId,
      teamId: params?.teamId,
    });

    reply = response ?? { success: false };
  } catch (error) {
    console.log(error);
    reply = { success: false };
  }

  return reply;
};

// ---------------------------------------------
// CREATE NEW PASSWORD
// ---------------------------------------------
export const newPasswordService = async (params) => {
  let reply;

  try {
    const hashedCurrentPassword = encryptText(params?.currentPassword);
    const hashedNewPassword = encryptText(params?.newPassword);

    const response = await connector.post("forgetPassword", "newPassword", {
      email: params?.email,
      currentPassword: hashedCurrentPassword,
      newPassword: hashedNewPassword,
    });

    reply = response ?? { success: false };
  } catch (error) {
    console.log(error);
    reply = { success: false };
  }

  return reply;
};

// ---------------------------------------------
// CREATE NEW USER
// ---------------------------------------------
export const createUserService = async (params) => {
  let reply;

  try {
    const response = await connector.post(controller, "newUser", {
      data: params?.data,
    });

    reply = response ?? { success: false };
  } catch (error) {
    console.log(error);
    reply = { success: false };
  }

  return reply;
};
